import { Space } from 'antd';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { EditOrganizationFormValues } from '../../../../../../../../types/organizationform';
import { AutoCompleteKeyMap } from '../../../../../../../components/GrispiInput/components/GrispiAutoCompleteInput';
import GrispiInput from '../../../../../../../components/GrispiInput/index';

const StandardOrganizationFieldsContainer = () => {
    const {
        t,
        i18n: { language }
    } = useTranslation('forms');

    return (
        <Space direction="vertical" className="full-width" size="small">
            <Controller<EditOrganizationFormValues, 'name'>
                key="name"
                name="name"
                render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => {
                    return (
                        <GrispiInput
                            containerProps={{
                                errorMessage: error?.message,
                                label: t('form.organization.label')
                            }}
                            type="TEXT"
                            onChange={onChange}
                            onBlur={onBlur}
                            value={value}
                            antdProps={{
                                placeholder: t('form.organization.placeholder'),
                                autoComplete: 'organization'
                            }}
                        />
                    );
                }}
                rules={{ required: t('form.required') }}
            />
            <Controller<EditOrganizationFormValues, 'notes'>
                key="notes"
                name="notes"
                render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => {
                    return (
                        <GrispiInput
                            containerProps={{
                                errorMessage: error?.message,
                                label: t('form.organizationNotes.label')
                            }}
                            type="TEXT"
                            onChange={onChange}
                            onBlur={onBlur}
                            value={value}
                            antdProps={{ placeholder: t('form.organizationNotes.placeholder') }}
                        />
                    );
                }}
            />
            <Controller<EditOrganizationFormValues, 'details'>
                key="details"
                name="details"
                render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => {
                    return (
                        <GrispiInput
                            containerProps={{
                                errorMessage: error?.message,
                                label: t('form.organizationDetails.label')
                            }}
                            type="TEXT"
                            onChange={onChange}
                            onBlur={onBlur}
                            value={value}
                            antdProps={{ placeholder: t('form.organizationDetails.placeholder') }}
                        />
                    );
                }}
            />
            <Controller<EditOrganizationFormValues, 'groupId'>
                key={language}
                name="groupId"
                render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => {
                    return (
                        <GrispiInput
                            containerProps={{ label: t('form.group.label'), errorMessage: error?.message }}
                            type="AUTOCOMPLETE"
                            autocompleteKey={AutoCompleteKeyMap.group}
                            value={value}
                            onBlur={onBlur}
                            onChange={onChange}
                            antdProps={{ placeholder: t('form.group.placeholder') }}
                        />
                    );
                }}
            />
        </Space>
    );
};

export default StandardOrganizationFieldsContainer;
